var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.47 5.78a.75.75 0 0 0 1.28-.53 1.5 1.5 0 0 1 1.5-1.5.75.75 0 1 0 0-1.5 1.5 1.5 0 0 1-1.5-1.5.75.75 0 1 0-1.5 0 1.5 1.5 0 0 1-1.5 1.5.75.75 0 1 0 0 1.5 1.5 1.5 0 0 1 1.5 1.5c0 .199.079.39.22.53m-7.177 9.927A1 1 0 0 0 7 15a4 4 0 0 1 4-4 1 1 0 0 0 0-2 4 4 0 0 1-4-4 1 1 0 0 0-2 0 4 4 0 0 1-4 4 1 1 0 0 0 0 2 4 4 0 0 1 4 4 1 1 0 0 0 .293.707",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgAi;